import { colors } from '@material-ui/core';
export default {
  styleOverrides: {
    root: {
      '&.Mui-focused': {
        border: 'none',
      },
    },
    notchedOutline: {
      // borderColor: 'rgba(0,0,0,0.15)',
      borderColor: colors.grey[500],
    },
  },
};
